import { SelectOption } from '@/const/types'

export const medicalCredentialOptions: SelectOption[] = [
	{ label: 'DC (Doctor of Chiropractic)', value: 'DC (Doctor of Chiropratic)' },
	{ label: 'DDM (Doctor of Dental Medicine)', value: 'DDM (Doctor of Dental Medicine)' },
	{ label: 'DDS (Doctor of Dental Surgery)', value: 'DDS (Doctor of Dental Surgery)' },
	{ label: 'DO (Doctor of Osteopathic Medicine', value: 'DO (Doctor of Osteophatic Medicine' },
	{ label: 'DPM (Doctor of Pediatric Medicine)', value: 'DPM (Doctor of Pediatric Medicine)' },
	{ label: 'MD (Doctor of Medicine)', value: 'MD (Doctor of Medicine' },
	{ label: 'OD (Doctor of Optometry)', value: 'OD (Optometry)' },
	{ label: 'PsyD (Doctor of Psychology)', value: 'PsyD (Doctor of Psychology)' }
]
